import React, { useState, useEffect } from "react";
import Navbar from "../../Components/Navbar";
import { fetchProfile } from "../../utils/fetchProfile";
import { dataStatModules } from "../../utils/constant";
import Cookies from "js-cookie";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Visibility from "@mui/icons-material/Visibility";
import { modalStyle } from "../../Components/Modal/Index";
import { Slide, toast } from "react-toastify";
import { fetchStoreMasterByStoreId } from "../AuditPlan/DataUtil";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Tooltip,
  IconButton,
  Modal,
  Box,
  Autocomplete,
  Grid,
} from "@mui/material";
import "../../style/setup.css";
import { ImportModalSetup } from "../../Components/Fragments/Modals/ModalSetupStoreImport";
import { exportproductmastersetup } from "../../services/productMasterService";
import { ModalConfirmation } from "../../Components/Fragments/Modals/ModalGeneral";

const tableCellStyle = {
  whiteSpace: "nowrap",
  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
  color: "#FFF",
  fontWeight: "bold",
  position: "sticky",
  top: 0,
  zIndex: 1000,
  minWidth: 120,
  textAlign: "center",
};

const BootstrapButton = styled(Button)({
  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
  border: "1px solid hsl(186, 89.90%, 27.30%)",
  borderRadius: "4px",
  color: "#fff",
  fontSize: { xs: "14px", sm: "16px" },
  padding: "4px 10px",
  textTransform: "none",
  "&:hover": {
    backgroundImage: "linear-gradient(#0991a2, #057d8c)",
  },
});

export function SetupStorePanelCellModal({
  editedData,
  setEditedData,
  selectedKodeOutletEdit,
  selectedPanelEdit,
  editModalOpen,
  isLoading,
  setIsLoading,
  handleModalStoreMasterSpecific,
  handleCloseEditModal, 
}) {
  const accessToken = Cookies.get("access_token") || "";
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  const [dataPanel, setDataPanel] = useState([]);
  const [dataAreaCellEdit, setDataAreaCellEdit] = useState([]);
  const [dataStoreTypes, setDataStoreTypes] = useState([]);
  const [dataCellsEdit, setDataCellsEdit] = useState([]);

  const [selectedCellCodeEdit, setSelectedCellCodeEdit] = useState(null);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchPanel();
      fetchStoreType();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchAreaCellEdit();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [editedData.panel]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchCellEdit();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [editedData.panel, editedData.areacell, editedData.storetypecode]);

  async function fetchPanel() {
    const token = Cookies.get("access_token");

    setDataPanel([]);

    const queryParams = new URLSearchParams();

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/panel` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: item.panel,
          value: item.panel,
        }));
        setDataPanel(newArray);
      } else {
        setDataPanel([]);
      }
    } catch (error) {
      setDataPanel([]);
    }
  }

  async function fetchStoreType() {
    const token = Cookies.get("access_token");

    setDataStoreTypes([]);

    const queryParams = new URLSearchParams();

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/stat/store-type` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: `${item.storetypecode} - ${item.storetype}`,
          value: item.storetypecode,
        }));
        setDataStoreTypes(newArray);
      } else {
        setDataStoreTypes([]);
      }
    } catch (error) {
      setDataStoreTypes([]);
    }
  }

  async function fetchAreaCellEdit() {
    if (editedData.panel) {
      const token = Cookies.get("access_token");

      setDataAreaCellEdit([]);

      const queryParams = new URLSearchParams();

      if (editedData.panel) {
        queryParams.append("panel", editedData.panel);
      }

      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/stat/areacell` +
        (queryString ? `?${queryString}` : "");

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const { data } = await response.json();
          const newArray = data.map((item) => ({
            label: `${item.areacell} - ${item.areacelldesc}`,
            value: item.areacell,
          }));
          setDataAreaCellEdit(newArray);
        } else {
          setDataAreaCellEdit([]);
        }
      } catch (error) {
        setDataAreaCellEdit([]);
      }
    }
  }

  async function fetchCellEdit() {
    if (
      editedData.panel &&
      editedData.areacell &&
      editedData.storetypecode !== undefined &&
      editedData.storetypecode !== null
    ) {
      const token = Cookies.get("access_token");

      setDataCellsEdit([]);

      const queryParams = new URLSearchParams();
      queryParams.append("panel", editedData.panel);
      queryParams.append("areacell", editedData.areacell);
      queryParams.append("storetypecode", editedData.storetypecode);

      const queryString = queryParams.toString();
      const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/stat/map/cellcode?${queryString}`;

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.ok) {
          const { data } = await response.json();
          const newArray = data.map((item) => ({
            label: item.cellcode_description,
            value: item.cellcode,
          }));

          if (data.length > 0) {
            const found = data.find(
              (item) => item.cellcode === editedData.cellcode
            );

            setEditedData((prev) => ({
              ...prev,
              cellcode: found ? found.cellcode : data[0].cellcode,
            }));
          } else {
            setEditedData((prev) => ({
              ...prev,
              cellcode: "0",
            }));
          }

          setDataCellsEdit(newArray);
        } else {
          setDataCellsEdit([]);
          setEditedData((prev) => ({ ...prev, cellcode: "0" }));
        }
      } catch (error) {
        setDataCellsEdit([]);
      }
    }
  }

  const selectedCellEdit = dataCellsEdit.find(
    (item) => item.value === editedData.cellcode
  );

  async function fetchCellByCellcodeEdit(cellcode) {
    if (cellcode === "0" || cellcode === "") {
      setSelectedCellCodeEdit("Tidak diproses");
      return;
    }

    const token = Cookies.get("access_token");
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/stat/map/cellcode?cellcode=${cellcode}`;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.ok) {
        const { data } = await response.json();
        if (data.length > 0) {
          setSelectedCellCodeEdit(data[0].cellcode_description);
        } else {
          setSelectedCellCodeEdit("Diproses");
        }
      } else {
        setSelectedCellCodeEdit("Diproses");
      }
    } catch (error) {
      setSelectedCellCodeEdit("Diproses");
    }
  }

  const handleUpdateData = async () => {
    setIsLoading(true);
    
    const queryParams = new URLSearchParams(); 
    
    const queryString = queryParams.toString();
    
  
    if (selectedKodeOutletEdit && selectedPanelEdit) {
      const token = Cookies.get("access_token");
      const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/stat/store-panel-cell/${selectedKodeOutletEdit}/${selectedPanelEdit}` + (queryString ? `?${queryString}` : '');

      try {
        const response = await fetch(apiUrl,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(editedData),
          }
        );
  
        if (response.status === 200) {
          toast.success("Data berhasil diubah!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
          handleCloseEditModal();
        } else if (response.status === 404) {
          const data = await response.json();
          toast.error(data.detail || "Data tidak ditemukan!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        } else if (response.status === 400 || response.status === 403) {
          const data = await response.json();
          toast.error(data.detail || "Data gagal diubah!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        } else if (response.status === 422) {
          toast.error("Data gagal diproses!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        } else {
          const data = await response.json();
          toast.error(data.detail || "Terjadi kesalahan!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        }
      } catch (error) {
        console.error(error);
        toast.error("Terjadi kesalahan jaringan!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      }
    }
    setIsLoading(false);
  };  

  return (
    <div style={{ padding: "1rem" }}>
    <Modal
      open={editModalOpen}
      onClose={handleCloseEditModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ border: 0 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: {
            xs: "90vw",
            sm: 400,
          },
          maxHeight: "90vh",
          bgcolor: "background.paper",
          border: "0px solid #000",
          boxShadow: 24,
          p: {
            xs: 2,
            sm: 4,
          },
          overflowY: "auto",
          borderRadius: 2,
        }}
      >
        <div className="edit-data">
          <h2>Edit Store Panel Cell</h2>
          <div>
            <TextField
              label="KODE OUTLET"
              name="kodeoutlet"
              value={editedData.kodeoutlet}
              onChange={(e) =>
                setEditedData({
                  ...editedData,
                  kodeoutlet: e.target.value,
                })
              }
              sx={{ width: "100%", mb: 2 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle store id visibility"
                      onClick={handleModalStoreMasterSpecific}
                      edge="end"
                    >
                      <Visibility />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              disabled
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Autocomplete
              options={dataPanel}
              getOptionLabel={(option) => option.label}
              value={
                dataPanel.find(
                  (option) => option.value === editedData.panel
                ) || null
              }
              onChange={(event, newValue) => {
                setEditedData({
                  ...editedData,
                  panel: newValue ? newValue.value : "",
                });
              }}
              sx={{ mb: 2 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="PANEL"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              disableClearable
            />
            <Autocomplete
              options={dataAreaCellEdit}
              getOptionLabel={(option) => option.label}
              value={
                dataAreaCellEdit.find(
                  (option) => option.value === editedData.areacell
                ) || null
              }
              onChange={(event, newValue) => {
                setEditedData({
                  ...editedData,
                  areacell: newValue ? newValue.value : "",
                });
              }}
              sx={{ mb: 2 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="AREA CELL"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              disableClearable
            />
            <Autocomplete
              options={dataStoreTypes}
              getOptionLabel={(option) => option.label}
              value={
                dataStoreTypes.find(
                  (option) => option.value === editedData.storetypecode
                ) || null
              }
              onChange={(event, newValue) => {
                setEditedData({
                  ...editedData,
                  storetypecode: newValue ? newValue.value : "",
                });
              }}
              sx={{ mb: 2 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="STORE TYPE STAT"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              disableClearable
            />
            <div
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <TextField
                label="CELL CODE"
                name="cellcode"
                value={editedData.cellcode}
                onChange={(e) => {
                  const value = e.target.value;
                  setEditedData({
                    ...editedData,
                    cellcode: value,
                  });

                  if (debounceTimeout) clearTimeout(debounceTimeout);

                  const timeout = setTimeout(() => {
                    fetchCellByCellcodeEdit(value);
                  }, 1000);
                  setDebounceTimeout(timeout);
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{ width: "29%", mb: 2 }}
              />
              <TextField
                label="CELL CODE DESCRIPTION"
                name="cellcode_description"
                value={
                  selectedCellEdit
                    ? selectedCellEdit.label
                    : selectedCellCodeEdit || "Tidak diproses"
                }
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{ width: "69%", mb: 2 }}
              />
            </div>
          </div>

          <div
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Button
              variant="outlined"
              disableRipple
              sx={{
                width: "50%",
                height: 50,
                mt: 2,
                color: "#b34469",
                borderColor: "#b34469",
              }}
              onClick={handleCloseEditModal}
            >
              Cancel
            </Button>
            <BootstrapButton
              variant="contained"
              disableRipple
              sx={{ width: "50%", height: 50, mt: 2, mr: 0, ml: 2 }}
              onClick={handleUpdateData}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "UPDATE"}
            </BootstrapButton>
          </div>
        </div>
      </Box>
    </Modal>
  </div>
  );
}

export default function SetupStorePanelCell() {
  const accessToken = Cookies.get("access_token") || "";
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  const [sortBy, setSortBy] = useState("storetype_description");
  const [sortOrder, setSortOrder] = useState("desc");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const itemsPerPageList = [5, 10, 50, 100];
  const [totalItems, setTotalItems] = useState("");
  const [filterColumnValue, setFilterColumnValue] = useState("");

  const [dataPanel, setDataPanel] = useState([]);
  const [dataAreaCell, setDataAreaCell] = useState([]);
  const [dataAreaCellEdit, setDataAreaCellEdit] = useState([]);
  const [dataStoreTypes, setDataStoreTypes] = useState([]);
  const [dataCells, setDataCells] = useState([]);
  const [dataCellsEdit, setDataCellsEdit] = useState([]);
  const [dataProfile, setDataProfile] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchBarValue, setSearchBarValue] = useState(
    "setup-store-panel-cell"
  );
  const [dataStoreMasterSpecific, setDataStoreMasterSpecific] = useState({});

  const [isModalOpenDetailStore, setIsModalOpenDetailStore] = useState(false);
  const [modalAddSetup, setModalAddSetup] = useState(false);

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editedData, setEditedData] = useState({});
  const [selectedKodeOutletEdit, setSelectedKodeOutletEdit] = useState(null);
  const [selectedPanelEdit, setSelectedPanelEdit] = useState(null);
  const [selectedCellCodeEdit, setSelectedCellCodeEdit] = useState(null);
  const [selectedCellCode, setSelectedCellCode] = useState(null);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deletedData, setDeletedData] = useState({});
  const [deleteDataId, setDeleteDataId] = useState(null);

  const [notAllowAccessPage, setNotAllowAccessPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [openDialogImport, setOpenDialogImport] = useState(false);
  const [excelFile, setExcelFile] = useState("");
  const [fileUrl, setFileUrl] = useState("");

  const [newData, setNewData] = useState({
    kodeoutlet: "",
    panel: "",
    areacell: 0,
    storetypecode: 0,
    cellcode: "0",
  });

  const [openDialogConfirmationExport, setOpenDialogConfirmationExport] = useState(false);
  const [viewDataExport, setViewDataExport] = useState({
    title: null,
    process_at: null,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProfile(accessToken, setDataProfile, setNotAllowAccessPage, [
        "13",
        "14",
        "TL",
        "COA",
        "A",
      ]);
      fetchPanel();
      fetchStoreType();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchMainData();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken, currentPage, itemsPerPage, sortBy, sortOrder]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchAreaCell();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [newData.panel]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchAreaCellEdit();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [editedData.panel]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchCell();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [newData.panel, newData.areacell, newData.storetypecode]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchCellEdit();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [editedData.panel, editedData.areacell, editedData.storetypecode]);

  async function fetchPanel() {
    const token = Cookies.get("access_token");

    setDataPanel([]);

    const queryParams = new URLSearchParams();

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/panel` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: item.panel,
          value: item.panel,
        }));
        setDataPanel(newArray);
      } else {
        setDataPanel([]);
      }
    } catch (error) {
      setDataPanel([]);
    }
  }

  async function fetchStoreType() {
    const token = Cookies.get("access_token");

    setDataStoreTypes([]);

    const queryParams = new URLSearchParams();

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/stat/store-type` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: `${item.storetypecode} - ${item.storetype}`,
          value: item.storetypecode,
        }));
        setDataStoreTypes(newArray);
      } else {
        setDataStoreTypes([]);
      }
    } catch (error) {
      setDataStoreTypes([]);
    }
  }

  async function fetchAreaCell() {
    if (newData.panel) {
      const token = Cookies.get("access_token");

      setDataAreaCell([]);

      const queryParams = new URLSearchParams();

      if (newData.panel) {
        queryParams.append("panel", newData.panel);
      }

      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/stat/areacell` +
        (queryString ? `?${queryString}` : "");

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const { data } = await response.json();
          const newArray = data.map((item) => ({
            label: `${item.areacell} - ${item.areacelldesc}`,
            value: item.areacell,
          }));
          setDataAreaCell(newArray);
        } else {
          setDataAreaCell([]);
        }
      } catch (error) {
        setDataAreaCell([]);
      }
    }
  }

  async function fetchAreaCellEdit() {
    if (editedData.panel) {
      const token = Cookies.get("access_token");

      setDataAreaCellEdit([]);

      const queryParams = new URLSearchParams();

      if (editedData.panel) {
        queryParams.append("panel", editedData.panel);
      }

      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/stat/areacell` +
        (queryString ? `?${queryString}` : "");

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const { data } = await response.json();
          const newArray = data.map((item) => ({
            label: `${item.areacell} - ${item.areacelldesc}`,
            value: item.areacell,
          }));
          setDataAreaCellEdit(newArray);
        } else {
          setDataAreaCellEdit([]);
        }
      } catch (error) {
        setDataAreaCellEdit([]);
      }
    }
  }

  async function fetchCell() {
    if (
      newData.panel &&
      newData.areacell &&
      newData.storetypecode !== undefined &&
      newData.storetypecode !== null
    ) {
      const token = Cookies.get("access_token");

      setDataCells([]);

      const queryParams = new URLSearchParams();
      queryParams.append("panel", newData.panel);
      queryParams.append("areacell", newData.areacell);
      queryParams.append("storetypecode", newData.storetypecode);

      const queryString = queryParams.toString();
      const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/stat/map/cellcode?${queryString}`;

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.ok) {
          const { data } = await response.json();
          const newArray = data.map((item) => ({
            label: item.cellcode_description,
            value: item.cellcode,
          }));

          if (data.length > 0) {
            setNewData((prev) => ({
              ...prev,
              cellcode: data[0].cellcode,
            }));
          } else {
            setNewData((prev) => ({
              ...prev,
              cellcode: "0",
            }));
          }

          setDataCells(newArray);
        } else {
          setDataCells([]);
          setNewData((prev) => ({ ...prev, cellcode: "0" }));
        }
      } catch (error) {
        setDataCells([]);
      }
    }
  }

  async function fetchCellEdit() {
    if (
      editedData.panel &&
      editedData.areacell &&
      editedData.storetypecode !== undefined &&
      editedData.storetypecode !== null
    ) {
      const token = Cookies.get("access_token");

      setDataCellsEdit([]);

      const queryParams = new URLSearchParams();
      queryParams.append("panel", editedData.panel);
      queryParams.append("areacell", editedData.areacell);
      queryParams.append("storetypecode", editedData.storetypecode);

      const queryString = queryParams.toString();
      const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/stat/map/cellcode?${queryString}`;

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.ok) {
          const { data } = await response.json();
          const newArray = data.map((item) => ({
            label: item.cellcode_description,
            value: item.cellcode,
          }));

          if (data.length > 0) {
            const found = data.find(
              (item) => item.cellcode === editedData.cellcode
            );

            setEditedData((prev) => ({
              ...prev,
              cellcode: found ? found.cellcode : data[0].cellcode,
            }));
          } else {
            setEditedData((prev) => ({
              ...prev,
              cellcode: "0",
            }));
          }

          setDataCellsEdit(newArray);
        } else {
          setDataCellsEdit([]);
          setEditedData((prev) => ({ ...prev, cellcode: "0" }));
        }
      } catch (error) {
        setDataCellsEdit([]);
      }
    }
  }

  const selectedCell = dataCells.find(
    (item) => item.value === newData.cellcode
  );
  const selectedCellEdit = dataCellsEdit.find(
    (item) => item.value === editedData.cellcode
  );

  async function fetchCellByCellcode(cellcode) {
    if (cellcode === "0" || cellcode === "") {
      setSelectedCellCode("Tidak diproses");
      return;
    }

    const token = Cookies.get("access_token");
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/stat/map/cellcode?cellcode=${cellcode}`;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.ok) {
        const { data } = await response.json();
        if (data.length > 0) {
          setSelectedCellCode(data[0].cellcode_description);
        } else {
          setSelectedCellCode("Diproses");
        }
      } else {
        setSelectedCellCode("Diproses");
      }
    } catch (error) {
      setSelectedCellCode("Diproses");
    }
  }

  async function fetchCellByCellcodeEdit(cellcode) {
    if (cellcode === "0" || cellcode === "") {
      setSelectedCellCodeEdit("Tidak diproses");
      return;
    }

    const token = Cookies.get("access_token");
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/stat/map/cellcode?cellcode=${cellcode}`;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.ok) {
        const { data } = await response.json();
        if (data.length > 0) {
          setSelectedCellCodeEdit(data[0].cellcode_description);
        } else {
          setSelectedCellCodeEdit("Diproses");
        }
      } else {
        setSelectedCellCodeEdit("Diproses");
      }
    } catch (error) {
      setSelectedCellCodeEdit("Diproses");
    }
  }

  async function fetchMainData(customParams = filterColumnValue) {
    const token = Cookies.get("access_token");

    setFilteredRows([]);
    setIsLoading(true);

    const queryParams = new URLSearchParams();

    queryParams.append("page", currentPage);
    queryParams.append("size", itemsPerPage);
    queryParams.append("sort_by", sortBy);
    queryParams.append("sort_order", sortOrder);

    if (customParams) {
      queryParams.append("column_value", customParams);
      queryParams.append("column_operator", "LIKE");
    }

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/stat/store-panel-cell` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setTotalItems(data.pagination_info.total);
        setFilteredRows(data.data);
      } else {
        setFilteredRows([]);
      }
    } catch (error) {
      setFilteredRows([]);
    }

    setIsLoading(false);
  }

  const handleModalStoreMasterSpecific = async () => {
    const data = await fetchStoreMasterByStoreId(
      accessToken,
      newData.kodeoutlet || editedData.kodeoutlet
    );
    if (data) {
      setDataStoreMasterSpecific(data);
      setIsModalOpenDetailStore(true);
    } else {
      alert("Kode Outlet tidak ditemukan atau tidak aktif");
    }
  };

  const handleCloseModalStoreMasterSpecific = () => {
    setDataStoreMasterSpecific({});
    setIsModalOpenDetailStore(false);
  };

  const handleTableSelection = (newValue) => {
    if (newValue) {
      setSearchBarValue(newValue.value);
      setTimeout(() => {
        window.location.href = newValue.value;
      }, 100);
    }
  };

  const handleSetupInputChange = (event) => {
    const { name, value } = event.target;
    setNewData({
      ...newData,
      [name]: value,
    });
  };

  const handleCreateData = async () => {
    const token = Cookies.get("access_token");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/stat/store-panel-cell`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newData),
        }
      );

      if (response.status === 201) {
        toast.success("Data berhasil dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        setModalAddSetup(false);
        setFilterColumnValue("");
        setCurrentPage(1);
        await fetchMainData("");
      } else if (
        response.status == 400 ||
        response.status == 403 ||
        response.status == 404
      ) {
        const data = await response.json();
        toast.error(data.detail || "Data gagal dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else if (response.status == 422) {
        toast.error("Data gagal diproses!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        const data = await response.json();
        toast.error(data.detail || "Data gagal dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      }
    } catch (error) {
      console.error("Error creating Data:", error);
    }
  };

  const handleAddNewSetup = () => {
    setEditedData({});
    setModalAddSetup(true);
  };

  const handleEditClick = async (row) => {
    setNewData({
      kodeoutlet: "",
      panel: "",
      areacell: 0,
      storetypecode: 0,
      cellcode: "",
    });
    setEditedData({
      kodeoutlet: row.kodeoutlet,
      panel: row.panel,
      areacell: row.areacell,
      storetypecode: row.storetypecode,
      cellcode: row.cellcode,
    });
    setSelectedKodeOutletEdit(row.kodeoutlet);
    setSelectedPanelEdit(row.panel);
    setEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    fetchMainData();
    setEditedData({});
    setEditModalOpen(false);
  }; 
  
  const handleDeleteClick = async (row) => {
    setDeletedData(row);
    setDeleteDataId(row.id);
    setDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  const handleDeleteData = async () => {
    setIsLoading(true);
    if (deleteDataId) {
      const bodyForm = {
        kodeoutlet: deletedData.kodeoutlet,
        panel: deletedData.panel,
        areacell: deletedData.areacell,
        storetypecode: deletedData.storetypecode,
        cellcode: deletedData.cellcode,
      };
      const token = Cookies.get("access_token");
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/stat/store-panel-cell`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(bodyForm),
          }
        );

        if (response.status === 200) {
          toast.success("Data berhasil dihapus!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
          setDeleteModalOpen(false);
          setFilterColumnValue("");
          setCurrentPage(1);
          await fetchMainData("");
        } else if (
          response.status == 400 ||
          response.status == 403 ||
          response.status == 404
        ) {
          const data = await response.json();
          toast.error(data.detail || "Data gagal dihapus!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        } else {
          const data = await response.json();
          toast.error(data.detail || "Data gagal dihapus!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
    setIsLoading(false);
  };

  const handleResetFilter = () => {
    setFilterColumnValue("");
    setCurrentPage(1);
    fetchMainData("");
  };

  const handleSearch = (e) => {
    e.preventDefault();

    setCurrentPage(1);
    fetchMainData();
  };

  // upload data

  const refreshData = () => {
    fetchMainData();
  };

  const handleImportData = () => {
    setOpenDialogImport(true);
  };

  const handleCloseDialog = () => {
    setOpenDialogImport(false);
    setExcelFile("");
    setFileUrl("");
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    await importDataTemplate();
    setIsLoading(false);
  };

  async function importDataTemplate() {
    try {
      const formData = new FormData();
      formData.append("file", excelFile);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/stat/store-panel-cell/import/template`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          body: formData,
        }
      );

      if (response.status === 201) {
        toast.success("Upload Store Panel Cell berhasil dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        setOpenDialogImport(false);
        //refresh
        setCurrentPage(1);
        refreshData();
      } else if (response.status === 200) {
        // throw data as blob then download it when validation on excel got fail
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Store Panel Cell Error.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        toast.error("Ada masalah di excel. Periksa kembali isi excel!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else if (response.status === 400) {
        const data = await response.json();
        toast.error(data.detail, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        toast.error("Gagal mengimport Store Panel Cell Setup!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        console.error(
          "Failed to import Store Panel Cell template:",
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error importing Store Panel Cell template:", error);
    }
  }

  async function exportDataTemplate() {
    setIsLoading(true);
    const blob = await exportproductmastersetup(
      accessToken,
      "template",
      "api/v1/stat/store-panel-cell/export/template",
      {}
    );
    if (blob) {
      // throw data as blob then download it
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Template Store Panel Cell.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else {
      toast.error("Gagal mendownload template Store Panel Cell!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
    }
    setIsLoading(false);
  }

  const handleProcessExport = async () => {
    setIsLoading(true);
    const token = Cookies.get("access_token");
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/process_queue/stat_module`;

    const body = {
      title: "Stat Module - Setup Store Panel Cell",
      setup: "store_panel_cell",
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (response.ok) {
        toast.success("Data akan diproses kedalam antrian.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        const data = await response.json();
        toast.error(data.detail || "Gagal memulai proses export!", {
          position: "top-right",
          autoClose: 5000,
        });
      }
    } catch (error) {
      toast.error("Terjadi kesalahan jaringan saat memulai proses export.");
    }
    setIsLoading(false);
  };

  const handleConfirmationExport = async () => {
    setIsLoading(true);

    const setup = "store_panel_cell";

    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/process_queue/stat_module/${setup}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (response.status === 200) {
      const { data } = await response.json();
      setOpenDialogConfirmationExport(true);
      setViewDataExport({
        title: data.data.title ?? "stat module - export result",
        process_at: data.process_at,
      });
    } else if (response.status === 400 || response.status === 404) {
      const { detail } = await response.json();
      toast.error(detail || "Data sedang diproses", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
    } else {
      const { detail } = await response.json();
      toast.error(detail || "Tidak ditemukan excel, klik Process terlebih dahulu", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
    }
    setIsLoading(false);
  };

  const handleCloseConfirmationExport = () => {
    setOpenDialogConfirmationExport(false);
    // clear data
    setViewDataExport({
      title: "",
      process_at: "",
    });
  };

  const handleExportResult = async () => {
    setIsLoading(true);
    try {
      const queryParams = new URLSearchParams();

      const setup = "store_panel_cell";

      // Construct the full URL with query parameters
      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/process_queue/stat_module/export/${setup}` +
        (queryString ? `?${queryString}` : "");

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status === 200) {
        const blob = await response.blob();
        const filename = `${viewDataExport.title || "stat module - export result"}.xlsx`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        handleCloseConfirmationExport();
      } else if (response.status === 400 || response.status === 404) {
        const data = await response.json();
        toast.error(data.detail, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        toast.error('Gagal mengunduh', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        console.error('Failed to export process queue:', response.statusText);
      }
    } catch (error) {
      console.error('Error export process queue:', error);
    }
    setIsLoading(false);
  };

  // pagination
  const handlePageChange = (event, page) => {
    setCurrentPage(page + 1);
  };

  const handleChangeItemPerPageSelect = (e) => {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  };

  // sorting
  const handleSort = (column) => {
    const isSorting = sortBy === column && sortOrder === "asc";
    setSortOrder(isSorting ? "desc" : "asc");
    setSortBy(column);
  };

  const sortTableCell = (label, sortByKey) => (
    <TableCell
      style={tableCellStyle}
      sx={{ border: 1, borderColor: "grey.300" }}
    >
      <TableSortLabel
        active={sortBy === sortByKey}
        direction={sortOrder}
        onClick={() => handleSort(sortByKey)}
        sx={{
          color: "#FFF !important",
          "&:hover": {
            color: "#FFF",
          },
          "& .MuiTableSortLabel-icon": {
            color: "#FFF !important",
          },
        }}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );

  if (notAllowAccessPage) {
    return (
      <div>
        <Navbar
          active="Stat Module"
          initial={dataProfile.initial}
          role_code={dataProfile.role_code}
        />
        <div>Not allowed to access this page</div>
      </div>
    );
  }

  return (
    <div>
      <Navbar
        active="Stat Module"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      />
      <div style={{ padding: "1rem" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: "10px",
            marginBottom: "15px",
          }}
        >
          <Grid container spacing={0.5}>
            <Grid item xs="auto" sm="auto">
              <Autocomplete
                options={dataStatModules}
                getOptionLabel={(option) => option.label}
                value={
                  dataStatModules.find(
                    (option) => option.value === searchBarValue
                  ) || null
                }
                onChange={(e, newValue) => handleTableSelection(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cari Kategori"
                    size="small"
                    style={{ width: "300px" }}
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                disableClearable
              />
            </Grid>
            <Grid item xs="auto" sm="auto">
              <form
                onSubmit={handleSearch}
                style={{ display: "flex", alignItems: "center" }}
              >
                <TextField
                  sx={{
                    mr: 0.5,
                    height: 40,
                  }}
                  name="column_value"
                  label="Cari"
                  size="small"
                  value={filterColumnValue}
                  onChange={(e) => {
                    setFilterColumnValue(e.target.value);
                  }}
                />
                <BootstrapButton
                  variant="contained"
                  disableRipple
                  sx={{ width: 120, height: 40 }}
                  type="submit"
                  disabled={isLoading || !filterColumnValue}
                >
                  {isLoading ? "Loading..." : "Cari"}
                </BootstrapButton>
              </form>
            </Grid>
            <Grid item xs="auto" sm="auto">
              <BootstrapButton
                variant="contained"
                disableRipple
                sx={{ width: 150, height: 40 }}
                onClick={handleResetFilter}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Reset Filter"}
              </BootstrapButton>
            </Grid>
            <Grid item xs="auto" sm="auto">
              <BootstrapButton
                variant="contained"
                disableRipple
                onClick={handleAddNewSetup}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Add"}
              </BootstrapButton>
            </Grid>
            <Grid item xs="auto" sm="auto">
              <BootstrapButton
                variant="contained"
                disableRipple
                onClick={handleImportData}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Upload"}
              </BootstrapButton>
            </Grid>
            <Grid item xs="auto" sm="auto">
              <BootstrapButton
                variant="contained"
                disableRipple
                onClick={handleProcessExport}
                disabled={isLoading}
                style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
              >
                {isLoading ? "Loading..." : "Process"}
              </BootstrapButton>
              <BootstrapButton
                variant="contained"
                disableRipple
                onClick={handleConfirmationExport}
                disabled={isLoading}
                style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
              >
                {isLoading ? "Loading..." : "Download"}
              </BootstrapButton>
            </Grid>
          </Grid>
        </div>

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 650 }}>
            <Table
              aria-label="simple table"
              sx={{
                border: 1,
                borderColor: "grey.300",
                borderCollapse: "collapse",
              }}
            >
              <TableHead>
                <TableRow>
                  {sortTableCell("Kode Outlet", "kodeoutlet")}
                  {sortTableCell("Panel", "panel")}
                  {sortTableCell("Area Cell", "areacell")}
                  {sortTableCell(
                    "Area Cell Description",
                    "areacell_description"
                  )}
                  {sortTableCell("Store Type Code", "storetypecode")}
                  {sortTableCell(
                    "Store Type Description",
                    "storetype_description"
                  )}
                  {sortTableCell("Cell Code", "cellcode")}
                  {sortTableCell(
                    "Cell Code Description",
                    "cellcode_description"
                  )}
                  <TableCell
                    style={tableCellStyle}
                    sx={{ border: 1, borderColor: "grey.300" }}
                  >
                    Aksi
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRows.length > 0 ? (
                  filteredRows.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.kodeoutlet}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.panel}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.areacell}
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.areacell_description}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.storetypecode}
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.storetype_description}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.cellcode}
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.cellcode_description}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        <Tooltip
                          title="Edit Data"
                          onClick={() => handleEditClick(row)}
                        >
                          <IconButton>
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip
                          title="Delete Data"
                          onClick={() => handleDeleteClick(row)}
                        >
                          <IconButton>
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={10}
                      align="center"
                      sx={{ border: 1, borderColor: "grey.300" }}
                    >
                      {isLoading ? "Loading..." : "No Data Available"}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {/* pagination */}
          {filteredRows.length > 0 && (
            <TablePagination
              rowsPerPageOptions={itemsPerPageList}
              component="div"
              count={totalItems}
              rowsPerPage={itemsPerPage}
              page={currentPage - 1}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleChangeItemPerPageSelect}
            />
          )}
        </Paper>

        <Modal
          open={modalAddSetup}
          onClose={() => setModalAddSetup(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ border: 0 }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: {
                xs: "90vw",
                sm: 400,
              },
              maxHeight: "90vh",
              bgcolor: "background.paper",
              border: "0px solid #000",
              boxShadow: 24,
              p: {
                xs: 2,
                sm: 4,
              },
              overflowY: "auto",
              borderRadius: 2,
            }}
          >
            <Tooltip title="Close Modal">
              <IconButton
                edge="end"
                color="inherit"
                onClick={() => setModalAddSetup(false)}
                sx={{ position: "absolute", top: 20, right: 30 }}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
            <div className="create-data">
              <h2 style={{ marginBottom: "15px" }}>Create Store Panel Cell</h2>
              <div>
                <TextField
                  label="KODE OUTLET"
                  name="kodeoutlet"
                  value={newData.kodeoutlet}
                  onChange={handleSetupInputChange}
                  sx={{ width: "100%", mb: 2 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle store id visibility"
                          onClick={handleModalStoreMasterSpecific}
                          edge="end"
                        >
                          <Visibility />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div>
                <Autocomplete
                  options={dataPanel}
                  getOptionLabel={(option) => option.label}
                  value={
                    dataPanel.find(
                      (option) => option.value === newData.panel
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleSetupInputChange({
                      target: {
                        name: "panel",
                        value: newValue ? newValue.value : "",
                      },
                    });
                  }}
                  sx={{ mb: 2 }}
                  renderInput={(params) => (
                    <TextField {...params} label="PANEL" />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disableClearable
                />
              </div>
              <div>
                <Autocomplete
                  options={dataAreaCell}
                  getOptionLabel={(option) => option.label}
                  value={
                    dataAreaCell.find(
                      (option) => option.value === newData.areacell
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleSetupInputChange({
                      target: {
                        name: "areacell",
                        value: newValue ? newValue.value : "",
                      },
                    });
                  }}
                  sx={{ mb: 2 }}
                  renderInput={(params) => (
                    <TextField {...params} label="AREA CELL" />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disableClearable
                />
              </div>
              <div>
                <Autocomplete
                  options={dataStoreTypes}
                  getOptionLabel={(option) => option.label}
                  value={
                    dataStoreTypes.find(
                      (option) => option.value === newData.storetypecode
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleSetupInputChange({
                      target: {
                        name: "storetypecode",
                        value: newValue ? newValue.value : "",
                      },
                    });
                  }}
                  sx={{ mb: 2 }}
                  renderInput={(params) => (
                    <TextField {...params} label="STORE TYPE STAT" />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disableClearable
                />
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <TextField
                  label="CELL CODE"
                  name="cellcode"
                  value={newData.cellcode}
                  onChange={(e) => {
                    const value = e.target.value;
                    setNewData({
                      ...newData,
                      cellcode: value,
                    });

                    if (debounceTimeout) clearTimeout(debounceTimeout);

                    const timeout = setTimeout(() => {
                      fetchCellByCellcode(value);
                    }, 1000);
                    setDebounceTimeout(timeout);
                  }}
                  sx={{ width: "29%", mb: 2 }}
                />
                <TextField
                  label="CELL CODE DESCRIPTION"
                  name="cellcode_description"
                  value={
                    selectedCell
                      ? selectedCell.label
                      : selectedCellCode || "Tidak diproses"
                  }
                  disabled
                  sx={{ width: "69%", mb: 2 }}
                />
              </div>
              <div>
                <BootstrapButton
                  variant="contained"
                  disableRipple
                  sx={{ width: "100%", mt: 2, height: 50, mb: 3 }}
                  onClick={handleCreateData}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Submit"}
                </BootstrapButton>
              </div>
            </div>
          </Box>
        </Modal>

        <SetupStorePanelCellModal
          editedData={editedData}
          setEditedData={setEditedData}
          selectedKodeOutletEdit={selectedKodeOutletEdit}
          selectedPanelEdit={selectedPanelEdit}
          editModalOpen={editModalOpen}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          handleModalStoreMasterSpecific={handleModalStoreMasterSpecific}
          handleCloseEditModal={handleCloseEditModal} 
        />

        <Modal
          open={deleteModalOpen}
          onClose={handleCloseDeleteModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ border: 0 }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: {
                xs: "90vw",
                sm: 400,
              },
              maxHeight: "90vh",
              bgcolor: "background.paper",
              border: "0px solid #000",
              boxShadow: 24,
              p: {
                xs: 2,
                sm: 4,
              },
              overflowY: "auto",
              borderRadius: 2,
            }}
          >
            <div className="delete-data">
              <h2>Hapus Data</h2>
              <p>Apakah anda yakin untuk menghapus data ini?</p>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="outlined"
                  disableRipple
                  sx={{
                    width: "50%",
                    height: 50,
                    mt: 2,
                    color: "#b34469",
                    borderColor: "#b34469",
                  }}
                  onClick={handleCloseDeleteModal}
                >
                  Tidak
                </Button>
                <BootstrapButton
                  variant="contained"
                  disableRipple
                  sx={{ width: "50%", height: 50, mt: 2, mr: 0, ml: 2 }}
                  onClick={handleDeleteData}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Ya"}
                </BootstrapButton>
              </div>
            </div>
          </Box>
        </Modal>

        <Modal
          open={isModalOpenDetailStore}
          onClose={handleCloseModalStoreMasterSpecific}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ border: 0 }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: {
                xs: "90vw",
                sm: 400,
              },
              maxHeight: "90vh",
              bgcolor: "background.paper",
              border: "0px solid #000",
              boxShadow: 24,
              p: {
                xs: 2,
                sm: 4,
              },
              overflowY: "auto",
              borderRadius: 2,
            }}
          >
            <h2>Store Master Detail</h2>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <div>
                  <b>Kode Outlet</b> : {dataStoreMasterSpecific.store_id}
                </div>
                <div>
                  <b>Nama Outlet</b> : {dataStoreMasterSpecific.store_name}
                </div>
                <div>
                  <b>Tipe Outlet</b> : {dataStoreMasterSpecific.store_type}
                </div>
                <div>
                  <b>Provinsi</b> : {dataStoreMasterSpecific.province_name}
                </div>
                <div>
                  <b>Kab/Kota</b> : {dataStoreMasterSpecific.regency_name}
                </div>
                <div>
                  <b>Kel</b> : {dataStoreMasterSpecific.sub_district_name}
                </div>
                <div>
                  <b>Kec</b> : {dataStoreMasterSpecific.district_name}
                </div>
                <Button
                  variant="outlined"
                  disableRipple
                  sx={{
                    width: 182,
                    mt: 2,
                    mr: 2,
                    height: 50,
                    color: "#b34469",
                    borderColor: "#b34469",
                  }}
                  onClick={handleCloseModalStoreMasterSpecific}
                >
                  Close
                </Button>
              </div>
            </div>
          </Box>
        </Modal>

        <ModalConfirmation
          open={openDialogConfirmationExport}
          onClose={handleCloseConfirmationExport}
          title={'Konfirmasi Download'}
          confirmationText={'Yes'}
          description={`Ditemukan ${viewDataExport.title} terakhir diproses pada ${viewDataExport.process_at}. Apakah anda yakin ingin download rawdata ini?`}
          isLoading={isLoading}
          handleClick={handleExportResult}
        />

        <ImportModalSetup
          isLoading={isLoading}
          open={openDialogImport}
          onClose={handleCloseDialog}
          title={"Import Store Panel Cell"}
          buttonTitle={"Upload"}
          fileUrl={fileUrl}
          handleSubmit={handleUpload}
          handleChange={{
            excel: setExcelFile,
            fileUrl: setFileUrl,
          }}
          handleExport={{
            template: exportDataTemplate,
          }}
        />
      </div>
    </div>
  );
}
